import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summaryMissing: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.summary-missing',
		defaultMessage:
			'<b>Missing summary</b>: Summary is a required field in Jira. It can be the task name or an overview of a task. Map the summary field to a CSV column to proceed with the import.',
		description: 'Missing summary field error',
	},
	issueIdMissing: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.issue-id-missing',
		defaultMessage:
			'<b>Missing issue IDs</b>: Issue links are dependent on issue IDs. Add the issue ID column to your import to ensure issue links are imported.',
		description: 'Missing issueid error',
	},
	emptySummary: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.empty-summary',
		defaultMessage:
			'<b>Missing summary content</b>: One or more cells in the CSV column mapped to the summary field are empty. Summary is a required field. Make sure to fill in the missing content and begin the import once again.',
		description: 'Empty summary error',
	},
	formattingErrorHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.formatting-error-heading',
		defaultMessage:
			'<b>Formatting error</b>: The data in the following CSV columns must match the selected field’s formatting style. Check and correct the format in the CSV column before restarting the import or remove the column from import.',
		description: 'Formatiing errors heading',
	},
	titleStandard: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.title-standard',
		defaultMessage:
			'{count, plural, one {We found # error in your import} other {We found # errors in your import}}',
		description: 'Error section message heading with count',
	},
});
